import { useState } from 'react';
import { useAuth } from '../context/AuthContext';

const styles = {
  wrapper: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#1a1a2e',
  },
  card: {
    backgroundColor: '#fff',
    borderRadius: 8,
    padding: 40,
    width: 360,
    boxShadow: '0 4px 24px rgba(0,0,0,0.15)',
  },
  logo: {
    fontSize: 28,
    fontWeight: 700,
    color: '#1a1a2e',
    marginBottom: 8,
    textAlign: 'center',
  },
  subtitle: {
    fontSize: 13,
    color: '#888',
    marginBottom: 28,
    textAlign: 'center',
  },
  label: {
    display: 'block',
    fontSize: 13,
    fontWeight: 500,
    color: '#555',
    marginBottom: 4,
  },
  input: {
    width: '100%',
    padding: '10px 12px',
    border: '1px solid #ddd',
    borderRadius: 4,
    fontSize: 14,
    marginBottom: 16,
    outline: 'none',
  },
  btn: {
    width: '100%',
    padding: '10px 16px',
    backgroundColor: '#4a9eff',
    color: '#fff',
    border: 'none',
    borderRadius: 4,
    fontSize: 14,
    fontWeight: 600,
    cursor: 'pointer',
  },
  error: {
    backgroundColor: '#fee',
    color: '#c0392b',
    padding: '8px 12px',
    borderRadius: 4,
    fontSize: 13,
    marginBottom: 16,
  },
};

export default function Login() {
  const { login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(username, password);
    } catch (err) {
      setError(err.message || 'Login failed');
    }
    setLoading(false);
  };

  return (
    <div style={styles.wrapper}>
      <form style={styles.card} onSubmit={handleSubmit}>
        <div style={styles.logo}>SubsData</div>
        <div style={styles.subtitle}>Subscription Management</div>
        {error && <div style={styles.error}>{error}</div>}
        <label style={styles.label}>Username</label>
        <input
          style={styles.input}
          value={username}
          onChange={e => setUsername(e.target.value)}
          autoFocus
        />
        <label style={styles.label}>Password</label>
        <input
          style={styles.input}
          type="password"
          value={password}
          onChange={e => setPassword(e.target.value)}
        />
        <button style={{ ...styles.btn, opacity: loading ? 0.7 : 1 }} disabled={loading}>
          {loading ? 'Signing in...' : 'Sign In'}
        </button>
      </form>
    </div>
  );
}
